import { Point } from '@app/shared/types/Point';
import { ClientRect, CollisionDetection } from '@dnd-kit/core';
import { DndCollision } from '../types';

function distanceBetween(p1: Point, p2: Point) {
  return (p1.x - p2.x) ** 2 + (p1.y - p2.y) ** 2;
}

function sortCollisionsAsc(collision1: DndCollision, collision2: DndCollision) {
  return collision1.data.distance - collision2.data.distance;
}

function getCorners(rectangle: ClientRect): [Point, Point, Point, Point] {
  const { left, top, right, bottom } = rectangle;
  return [
    { x: left, y: top },
    { x: right, y: top },
    { x: left, y: bottom },
    { x: right, y: bottom },
  ];
}

export const collisionDetection: CollisionDetection = ({
  active,
  collisionRect,
  droppableRects,
  droppableContainers,
}): DndCollision[] => {
  const corners = getCorners(collisionRect);
  const collisions: DndCollision[] = [];

  const draggedRect = active.rect.current.translated;

  if (!draggedRect) {
    return [];
  }

  for (const droppableContainer of droppableContainers) {
    const { id } = droppableContainer;
    const rect = droppableRects.get(id);

    if (rect) {
      // we check if there is collision
      if (
        draggedRect.left <= rect.right - 2 &&
        draggedRect.right >= rect.left + 2 &&
        draggedRect.top <= rect.bottom - 2 &&
        draggedRect.bottom >= rect.top + 2
      ) {
        // in case of collision, we calculate the distance between the corners of the dragged element and the corners of the droppable element to find the closest one
        const rectCorners = getCorners(rect);
        const distance = corners.reduce(
          (accumulator, corner, index) =>
            accumulator + distanceBetween(rectCorners[index], corner),
          0,
        );
        collisions.push({
          id,
          data: {
            droppableContainer,
            distance,
          },
        });
      }
    }
  }

  return collisions.sort(sortCollisionsAsc);
};
